import type { Component } from 'vue';

export type WizardStepGuard = () => unknown;

export type WizardFooterFlag = boolean | (() => boolean);

export type WizardFooterConfig = {
  nextLabel?: string;
  backLabel?: string;
  submitLabel?: string;
  hideBack?: WizardFooterFlag;
  hideNext?: WizardFooterFlag;
  nextDisabled?: () => boolean;
  nextDisabledReason?: string | (() => string | undefined);
  nextLoading?: () => boolean;
  onNext?: WizardStepGuard;
  onSubmit?: WizardStepGuard;
  startComponent?: Component;
  startProps?: Record<string, unknown>;
};

export type WizardStep = {
  name: string;
  label: string;
  title?: string;
  description?: string;
  descriptionComponent?: Component;
  component?: Component;
  footer?: WizardFooterConfig;
  isRecap?: boolean;
};

export type WizardSidebarProps = {
  namespace: string;
  testId?: string;
};

export const WizardState = {
  Completed: 'completed',
  Current: 'current',
  Upcoming: 'upcoming',
} as const;

export type WizardState = (typeof WizardState)[keyof typeof WizardState];
